import { SxProps, Theme } from '@mui/material';

export const DpTextH4SX: SxProps<Theme> = {
	fontSize: {
		xs: 'var(--font-size-lg)',
		sm: 'var(--font-size-xl)',
	},
	fontWeight: '800',
	color: '#2C2C2C',
};

export const DpTextH4DisSX: SxProps<Theme> = {
	fontSize: 'var(--font-size-lg)',
	fontWeight: '800',
	color: '#2C2C2C',
};
